module.exports = __webpack_public_path__ + "media/background-pc.2df930bb.mp4";